<div class="pl-dropdown" [class.form-submitted]="isFormSubmitted">
  <form class="example-form" [formGroup]="form">
    <mat-form-field floatLabel="always" subscriptSizing="dynamic" appearance="outline" class="w-full">
      <mat-label>{{ label }}</mat-label>
      <input
        type="text"
        class="!font-sans !text-pl-gray-450 !subpixel-antialiased !caret-current"
        [placeholder]="placeholder"
        [attr.aria-label]="label"
        matInput
        [formControlName]="FormControlName.dropdown"
        [matAutocomplete]="auto"
      />
      <pl-icon
        [frame]="IconFrame.round"
        [name]="PlIcon.close"
        (click)="clearInputValue($event)"
        class="absolute -right-2 bottom-0 top-0 z-10 my-auto h-8 w-8 cursor-pointer border-transparent bg-transparent text-pl-gray-700 hover:bg-pl-gray-200"
        [ngClass]="{
          'text-pl-gray-300': isDisabled
        }"
      />

      <mat-autocomplete
        autoActiveFirstOption
        #auto="matAutocomplete"
        [autoActiveFirstOption]="false"
        [autoSelectActiveOption]="false"
        [hideSingleSelectionIndicator]="true"
      >
        <mat-option
          *ngFor="let option of filteredOptions()"
          [value]="option"
          class="pl-mat-option font-sans subpixel-antialiased"
        >
          <span class="block w-full truncate">{{ option }}</span>
        </mat-option>
      </mat-autocomplete>
      <mat-hint
        *ngIf="controlDir.control?.errors && controlDir?.control?.dirty && isFormSubmitted"
        align="start"
        class="text-xs text-pl-error"
      >
        <span *ngIf="controlDir.control?.errors?.['required']">
          {{ 'errors.required_enter_value' | translate }}
        </span>

        <span *ngIf="controlDir.control?.errors?.['maxlength']">
          {{ 'errors.max_characters' | translate: { max: controlDir.control?.errors?.['maxlength'].requiredLength } }}
        </span>
      </mat-hint>
    </mat-form-field>
  </form>
</div>
